__turbopack_context__.v({
  "react-multi-carousel-list": "contact-us-module-scss-module__0MCBoG__react-multi-carousel-list",
  "react-multiple-carousel__arrow--left": "contact-us-module-scss-module__0MCBoG__react-multiple-carousel__arrow--left",
  "react-multiple-carousel__arrow--right": "contact-us-module-scss-module__0MCBoG__react-multiple-carousel__arrow--right",
});
